export const agentApis = {
    getAgentDetails: 'agents/details?Id',
    getCounselorDetails: 'counsellor/details?Id',
    editAgentDetails: 'agents?id',
    uploadDoc: 'agentDocUpload/website?agentId',
    getDocsList: 'agentDocUpload?skip=0&limit=20&agentId',
    status:'agentAuth/forgotPassword',
    agent:'agents/singup',
    getEditAgent:'agents/details?Id=',
    checkOldPass: 'agentAuth/checkPassword',
    resetPass: 'agentAuth/resetPassword',
    agentBankDetails: 'agents/bankDetails?agentsId=',
    // counsellor
    counsellor: 'counsellor',
    editCounsellorDetails: 'counsellor?id',
    counsellorInvite: 'agentAproval/resentInviteCounsellor?Id=',
    getEditCounsellor: 'counsellor/details?Id=',
    updateProfilePicture: 'agentDocUpload/uploadProfileImage',
    agentMakeCall: 'ipbx/dial_agent_outbound',
    setDefaultBank: 'agents/bankDetailsDefaultAccount?agentsId=',
    getMouForAgents: 'emailTemplates/emailTemplateSend?tenantId=:tenantId&eventTypeId=Email%2FPDF-MOU&agentId=:agentId',
    getFine:'agents/checkFine',
    getOTPForAgents: 'agents/getOTP',
    checkOTPAgents: 'agents/checkOTP',
    addCounsillors:'counsellor/addCounsillors',
};